import Cookies from 'js-cookie';

class CookiesNotice {
    constructor() {
        this.DAY_MILLISECONDS = 24 * 60 * 60 * 1000;
        this.showDelay = 1500;
        this.cookieName = 'alert-cookie-accepted';
        this.date = new Date().getTime();
    }

    /**
     * Метод инициализирует модуль
     * @param {HTMLElement} wrapper - обертка компонента.
     */
    init(wrapper) {
        this.wrapper = wrapper;
        this.timer = this.wrapper.dataset.timer || false;
        this.button = this.wrapper.querySelector('.j-cookies-notice__button');
        this._bindEvents();
        this._check();
    }

    /**
     * Метод навешивает обработчики на элементы
     * @private
     */
    _bindEvents() {
        this.button.addEventListener('click', this._close.bind(this));
    }

    /**
     * Метод проверяет наличие куки
     * @private
     */
    _check() {
        // Дата, когда была записана кука
        const cookiesTime = Cookies.get(this.cookieName);
        // Сколько прошло времени
        const spentTime = this.date - cookiesTime;
        // Если стоит таймер
        const timerData = this.timer ? this.DAY_MILLISECONDS * this.timer : 0;
        // Когда истекает запись
        const dateOver = cookiesTime + timerData;

        if (!cookiesTime) {
            this._show();
        } else if ((spentTime > dateOver) && this.timer) {
            Cookies.remove(this.cookieName);
            this._show();
        }
    }

    /**
     * Метод показывает уведомление.
     * @private
     */
    _show() {
        // Добавляем доп класс, что-бы уведомление не прыгало при загрузке страницы
        this.wrapper.classList.add('is-show');

        setTimeout(() => {
            this.wrapper.classList.add('is-open');
        }, this.showDelay);
    }

    /**
     * Метод закрывает уведомление и устанавливает куку.
     * @private
     */
    _close() {
        Cookies.set(this.cookieName, this.date);

        this.wrapper.classList.remove('is-open');
        this.wrapper.classList.remove('is-show');
    }
}

export default CookiesNotice;
